/** Mirrors `odometerMaxNumber` in VehicleDealBooking (kept here to stay free of React imports). */
export const ODOMETER_MAX = 250000

export interface VehiclePrefill {
  make?: string
  model?: string
  regdate?: string
  odometer?: number
  horsePower?: string
  payoutAmount?: number
  fuel?: 'diesel' | 'petrol'
}

/**
 * Vehicle details handed over by the AI appraisal flow. Numbers are validated
 * loosely here — the form validation still applies once the user submits.
 */
export function parseVehiclePrefill(
  params: Record<string, string | (string | null)[] | null>,
): VehiclePrefill {
  const str = (key: string) => {
    const value = params[key]
    return typeof value === 'string' && value.trim() ? value.trim() : undefined
  }
  const num = (key: string, min: number, max: number) => {
    const value = Number(str(key))
    return Number.isFinite(value) && value >= min && value <= max
      ? value
      : undefined
  }
  const currentYear = new Date().getFullYear()
  const fuel = str('kraftstoff')
  const regdate = num('zulassungsjahr', 1950, currentYear)
  const horsePower = num('ps', 1, 2000)
  return {
    make: str('marke'),
    model: str('modell'),
    regdate: regdate ? String(regdate) : undefined,
    odometer: num('km', 0, ODOMETER_MAX),
    horsePower: horsePower ? String(horsePower) : undefined,
    payoutAmount: num('betrag', 0, 1_000_000),
    // the appraisal flow says "benzin", the form model "petrol"
    fuel:
      fuel === 'diesel'
        ? 'diesel'
        : fuel === 'benzin' || fuel === 'petrol'
          ? 'petrol'
          : undefined,
  }
}
